import { WireTypes } from "@flakiness/server/common/wireTypes.js";
import { markdown } from "../markdown.js";
import { ciTabs } from "./welcome_ci_tabs.js";
import { otherCITabs } from "./welcome_other_ci.js";

const ghaOIDCInstructions = (project: WireTypes.Project) => markdown`
  Enable the \`id-token: write\` permission in your workflow. GitHub Actions ships with \`npx\`, so \`@flakiness/junit-xml\` runs without a separate install step:

  ${markdown.yaml(`
    permissions:
      contents: read # Required for actions/checkout
      id-token: write # Required for GitHub OIDC

    steps:
      - uses: actions/checkout@v4
      - uses: oven-sh/setup-bun@v2
      - run: bun install
      - name: Run tests
        run: bun test --reporter=junit --reporter-outfile=./junit.xml
      - name: Convert and upload to Flakiness.io
        if: always()
        run: npx @flakiness/junit-xml ./junit.xml --category bun --flakiness-project ${project.org.orgSlug}/${project.projectSlug}
  `, `.github/workflows/tests.yml`, { ins: [[1, 3], [9, 13]] })}
`;

const gitlabOIDCInstructions = (project: WireTypes.Project) => markdown`
  GitLab mints the ID token when the job starts, so declare one named \`FLAKINESS_ID_TOKEN\` with your project as its audience. The upload runs in \`after_script\`, which executes even when tests fail:

  ${markdown.yaml(`
    test:
      id_tokens:
        FLAKINESS_ID_TOKEN:
          aud: ${project.org.orgSlug}/${project.projectSlug} # Required for GitLab OIDC
      script:
        - bun install
        - bun test --reporter=junit --reporter-outfile=./junit.xml
      after_script:
        - bunx @flakiness/junit-xml ./junit.xml --category bun --flakiness-project ${project.org.orgSlug}/${project.projectSlug}
  `, `.gitlab-ci.yml`, { ins: [[2, 4], [8, 9]] })}
`;

export const welcome_bun = (project: WireTypes.Project) => {
  const otherCi = otherCITabs({
    idPrefix: 'bun',
    project,
    testCommand: 'bun test --reporter=junit --reporter-outfile=./junit.xml',
    junitPath: './junit.xml',
    category: 'bun',
  });
  return markdown`

\`bun test\` has built-in JUnit XML output. Run it with \`--reporter=junit\`, then use [\`@flakiness/junit-xml\`](https://github.com/flakiness/junit-xml) to convert and upload the report.

${ciTabs({
  idPrefix: 'bun',
  project,
  githubActions: ghaOIDCInstructions(project),
  gitlabCI: gitlabOIDCInstructions(project),
  otherCI: otherCi,
})}
`;
};
